function prepareForAnimation() {
  var screenWidth = $(window).width();

  var element = $('section.animate, article.animate, div.animate, footer.animate');

  var counted = false
  // Window stuff
  $(window).scroll(function () {
    addClassIfVisible(element);
  });

  addClassIfVisible(element);

} export default prepareForAnimation

function addClassIfVisible(element) {
  element.each(function () {
    if (isScrolledIntoView(this)) {
      $(this).addClass('is-visible');
    }
  });
}

function isScrolledIntoView(element) {
  var scrollBottomPosition = $(window).scrollTop() + ($(window).height());
  return ($(element).offset().top < scrollBottomPosition);
}
